module.exports = __webpack_public_path__ + "media/images/brands/logo_energiefranken_klein-c3d895209282cf93db85dd6c489a407b.svg";